<template>
  <div>
      <vue-components style="height: 88vh;" v-model="contents" ref="myQuillEditor"  @change="onEditorChange"></vue-components>

      <div>
        <div style="position: absolute; width: 60px;  height: 60px; border-radius: 50%;  background: #269fcf;  right: 50px; bottom: 70px; text-align: center;  line-height: 56px;  color: #fff;">
          <div @click="handleSven">保存</div>
        </div>
      </div>

  </div>
</template>

<script>

import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
import loadingUtils from "../utils/loading";
import 'animate.css'

import axios from "axios";
import apiBaseUrl from "../../config/api";

export default {
  name: 'CKEditorLoding',
  props: {
    content: {
      type: String,
      default: ''
    },
    Row: {
      type: Object,
      default: {}
    }

  },
  data() {
    return {
        contents:'',
    }
  },

  mounted() {

    const toolbar = this.$refs.myQuillEditor.quill.getModule('toolbar')
    toolbar.addHandler('image', this.imageHandler)
    toolbar.addHandler('video', this.videoHandler)

    this.handleInit()

  },

  methods: {

    handleInit() {
       axios.get(`${apiBaseUrl}/wikiDocument/getOne/${this.Row.id}`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then(response => {
            if (response.data.code === 200) {
                this.contents = response.data.data.content ? response.data.data.content : '' 
            } else {
              this.$message.error(response.data.message || response.data.meg);
            }
       }).catch((error) => {})
    },

    handleSven(){
      loadingUtils.startLoading()
      axios.post(`${apiBaseUrl}/wikiDocument/update`, { "categoryId": this.Row.id,  "content": this.contents ? this.contents : ''},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then(response => {
        if (response.data && response.data.code === 200) {
            this.$message.success(response.data.message || '保存成功');
            setTimeout(() => {
              loadingUtils.endLoading()
              this.$emit('handleSvenReree', this.Row.id)
              this.contents = ''
            },500)
        } else {
          this.$message.error(response.data.message || response.data.meg);
        }
      }).catch((error) => {
        loadingUtils.endLoading()
        this.$message.error(error);
      });  
    },

    onEditorChange({ html }) {
      console.log('Editor content changed:', html)
    },

    imageHandler() {
      this.upload('image')
    },

    videoHandler() {
      this.upload('video')
    },


    upload(type) {
      const input = document.createElement('input')
      input.setAttribute('type', 'file')
      input.setAttribute('accept', type === 'image' ? 'image/*' :  type === 'video' ? 'video/*' : 'audio/*')
      input.click()

      input.onchange = () => {
        const file = input.files[0]
        if (!file) return

        // 校验文件大小（例如：图片 ≤10MB，视频 ≤100MB）
        const maxSize = type === 'image' ? 10 * 1024 * 1024 : 100 * 1024 * 1024
        if (file.size > maxSize) {
          alert(`${type === 'image' ? '图片' : '视频'}大小不能超过 ${maxSize / 1024 / 1024}MB`)
          return
        }

        // 生成唯一文件名
        const fileExt = file.name.substring(file.name.lastIndexOf('.'))
        const fileName = `${getFileNameUUID()}${fileExt}`
        const objectName = `${type === 'image' ? 'images' : 'images'}/${fileName}`

        // 步骤1：上传到 OSS
        put(objectName, file)
          .then(() => {
            // 步骤2：获取外链 URL
            return signatureUrl(objectName)
          })
          .then((url) => {

            const urls = `https://mz-app-develop.oss-cn-beijing.aliyuncs.com/${objectName}`

            // 步骤3：插入到编辑器
            const quill = this.$refs.myQuillEditor.quill
            const range = quill.getSelection()
            const index = range ? range.index : quill.getLength()

            if (type === 'image') {
              quill.insertEmbed(index, 'image', urls)
            } 
            else if (type === 'audio') {
              quill.insertEmbed(index, 'audio', urls)
            } 
            else {
              quill.insertEmbed(index, 'video', urls)
            }

            // 光标后移
            quill.setSelection(index + 1)
          })
          .catch((error) => {
            console.error('上传失败:', error)
            alert('上传失败，请重试')
          })
      }
    }

  },
}
</script>

<style scoped lang="less">

</style>


// WEBPACK FOOTER //
// src/CKEditor/CKEditorLoding.vue